module.exports = __webpack_public_path__ + "static/media/rolunk-bg_1920.e409bc18.jpg";